import i18next from 'i18next'

i18next.addResourceBundle('en', 'users', {
    add_user: 'Add User',
    edit_user: 'Edit User',
    search_placeholder: 'Search by username, name, or email',
    users_table: {
        username: 'Username',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        full_name: 'Full Name',
        groups: 'Groups',
        last_login: 'Last Login',
        never_logged_in: 'Never',
        actions: 'Actions',
        email_not_verified: 'Email not verified',
    },
    confirm_delete_user: 'Are you sure you want to delete this user?',
    confirm_deletion: 'Confirm Deletion',
    first_last: 'First Last',
    last_first: 'Last First',
    other: 'Custom',
    details: 'Details',
    design_repositories: 'Design Repositories',
    deploy_repositories: 'Deploy Repositories',
    default_design_repository_role: 'Default role for design repositories',
    default_design_repository_role_tooltip: 'Default role will be applied to all Design Repositories',
    default_deploy_repository_role: 'Default role for deploy repositories',
    default_deploy_repository_role_tooltip: 'Default role will be applied to all Deploy Repositories',
    projects: 'Projects',
    account: 'Account',
    name: 'Name',
    edit_modal: {
        username: 'Username',
        email: 'Email',
        password: 'Password',
        first_name: 'First Name',
        first_name_info: 'Given Name',
        last_name: 'Last Name',
        last_name_info: 'Family Name',
        display_name: 'Display Name',
        groups: 'Groups',
        create: 'Create',
        update: 'Update',
        cancel: 'Cancel',
        first_name_max_length: 'First Name must be at most 25 characters long',
        last_name_max_length: 'Last Name must be at most 25 characters long',
        display_name_max_length: 'Display Name must be at most 64 characters long',
        display_name_required: 'Display Name is required',
        password_required: 'Password is required',
        email_required: 'Email is required',
        email_invalid: 'Invalid email address',
        email_max_length: 'Email must be at most 254 characters long',
        username_required: 'Username is required',
        change_password: 'Change Password',
        current_password: 'Current Password',
        new_password: 'New Password',
        confirm_password: 'Confirm Password',
    },
    settings: {
        table_settings: 'Table Settings',
        show_header: 'Show Header',
        show_formulas: 'Show Formulas',
        default_order: 'Default Order',
        testing_settings: 'Testing Settings',
        tests_per_page: 'Tests Per Page',
        failures_only: 'Failures Only',
        compound_result: 'Compound Result',
        trace_settings: 'Trace Settings',
        show_numbers_without_formatting: 'Show Numbers Without Formatting',
    },
    action: {
        delete_user: 'Delete User',
    },
    resend_verification_email: 'Resend Verification Email',
    resend_verification_email_timer: 'You can request a new email in {{seconds}} seconds.',
    email_verification_warning: 'Please verify your new email address. Check your mailbox for a verification link.',
    email_verified_title: 'Email verified!',
    email_verified_message: 'Your email address has been successfully verified.',
    email_verified_redirect: 'You will be redirected to the main page in {{seconds}} seconds...',
    go_to_main_page: 'Go to OpenL Studio',
    verification_failed_title: 'Verification failed',
    verification_failed_message_1: 'We could not verify your email. The link may be invalid or expired.',
    verification_failed_message_2: 'Please request a new verification email or contact support.',
    verification_failed_resend_prompt: 'If you want to receive a new verification email, click the button below:',
    send_verification_email: 'Send Verification Email',
    cannot_determine_current_user: 'Cannot determine current user.',
    verification_email_sent: 'Verification email sent. Please check your mailbox.',
    failed_to_send_verification_email: 'Failed to send verification email.',
    user_profile_updated_successfully: 'User profile updated successfully',
    user_settings_updated_successfully: 'User settings updated successfully',
    profile_completion: {
        title: 'Complete Your Profile',
        description: 'Enter the missing profile details to continue to OpenL Studio.',
        email: 'Email',
        email_placeholder: 'Enter your email address',
        email_required: 'Email is required',
        email_invalid: 'Please enter a valid email',
        email_max_length: 'Email must be at most 254 characters long',
        first_name: 'First Name',
        first_name_placeholder: 'Enter your first name',
        first_name_max_length: 'First name must be at most 25 characters long',
        last_name: 'Last Name',
        last_name_placeholder: 'Enter your last name',
        last_name_max_length: 'Last name must be at most 25 characters long',
        display_name: 'Display Name',
        display_name_placeholder: 'Enter your display name',
        display_name_required: 'Display name is required',
        display_name_max_length: 'Display name must be at most 64 characters long',
        display_name_first_last: 'First Last',
        display_name_last_first: 'Last First',
        display_name_other: 'Custom',
        save: 'Save',
        saved: 'Profile Updated',
        saved_description: 'Your profile information has been saved.',
        save_failed: 'Failed to save profile information.',
    },
    unsafe_default_password: 'Unsafe default password',
    cannot_delete_superuser: 'Cannot delete a super administrator',
    cannot_delete_yourself: 'Cannot delete your own account',
    failed_to_load_root_repository_roles: 'Failed to load root repository roles. Please try again later.',
    failed_to_save_root_repository_roles: 'Failed to save root repository roles. Please try again later.',
    failed_to_load_projects: 'Failed to load projects. Please try again later.',
    some_role_operations_failed: '{{count}} role operation(s) failed. The rest were applied. Please retry the failed ones or check the server.',
})
